export default {
  executionHistory: {
    title: '执行历史',
    refresh: '刷新',
    filter: {
      execution_id: '执行ID',
      req_id: '请求ID',
      workflow: '工作流',
      workflowPlaceholder: '工作流名称',
      version: '版本',
      protocol: '执行标识',
      protocolPlaceholder: '执行标识名称',
      env: '环境',
      timeRange: '时间范围',
      startTime: '开始时间',
      endTime: '结束时间',
      clientInfo: '客户端信息',
      selectField: '选择字段',
      inputValue: '请输入筛选值',
      add: '添加',
      reset: '重置',
      columnManagement: '列管理',
      placeholder: '请输入',
      sortByStartTime: '按开始时间排序',
      earliest: '最早',
      latest: '最晚',
      allStatus: '全部状态',
      status: '状态',
      triggerBy: '触发方式',
      all: '全部',
      knitConsole: 'Knit Console',
      api: 'API',
      schedule: '定时任务',
      webhook: 'Webhook',
      customAttributes: '自定义属性',
      value: '值',
      resetAll: '重置全部',
    },
    clientFields: {
      gameid: '游戏ID',
      protouid: '执行标识UID',
      sessionid: 'SessionID',
      userid: '用户ID',
      requestid: '请求ID',
    },
    table: {
      columns: {
        execution_info: '执行信息',
        req_id: '请求ID',
        env: '环境',
        status: '执行结果',
        client_info: '客户端信息',
        duration: '执行时长',
        created_at: '执行时间',
        session_id: '会话ID',
        publish_version: '版本',
        protocol: '执行标识',
        start_time: '开始时间',
        run_time: '运行时间',
        execution_id: '执行ID',
        trigger_by: '触发方式',
        custom_attributes: '自定义属性',
      },
      status: {
        success: 'success',
        error: 'error',
      },
      unknownWorkflow: '未知工作流',
      executedAt: '执行于',
      noValue: '无',
      query: '查询',
      executionIdLabel: '执行ID',
      requestIdLabel: '请求ID',
    },
    shortcuts: {
      last1Hour: '近1小时',
      last6Hours: '近6小时',
      last12Hours: '近12小时',
      last1Day: '近1天',
      last3Days: '近3天',
      last7Days: '近7天',
    },
    messages: {
      selectField: '请选择筛选字段',
      inputValue: '请输入筛选值',
      successExport: '成功导出 {count} 条数据',
      errorExport: '导出失败，请重试',
    },
  },
  executionDetail: {
    title: '执行记录',
    details: '执行详情',
    protocol: '执行标识',
    env: '环境',
    scheduleInterval: '调度间隔',
    duration: '执行时长',
    updatedAt: '更新于',
    createdAt: '创建于',
    goToWorkflow: '前往工作流',
    viewLogs: '查看工作流日志',
    actions: {
      backToLogs: '返回执行历史',
      backToRunTasks: '返回 Run Tasks',
      saveAsTestCase: '保存为 test case',
    },
    messages: {
      loadFailed: '加载执行记录详情失败',
      loadSubWorkflowFailed: '获取子工作流节点失败',
    },
  },
  saveExecuteExample: {
    saveAsExample: '保存为示例',
    exampleName: '示例名称',
    exampleNamePlaceholder: '请输入示例名称',
    exampleCatalog: '示例目录',
    exampleCatalogPlaceholder: '请输入示例目录',
  },
  executionLog: {
    nodeConfig: '查看节点配置',
    more: '更多',
    subWorkflowExecutionRecord: '子工作流执行记录',
    subWorkflowConfig: '子工作流配置',
    tabs: {
      result: '输出结果',
      detail: '详情',
      prompt: '提示词',
      raw: '原始数据',
    },
    titlePostfix: '执行日志',
    noLoopLog: '暂无循环节点日志',
    recordTitle: '第 {index} 次执行',
    details: {
      nodeName: '节点名称',
      nodeDescription: '节点描述',
      nodeId: '节点ID',
      nodeType: '节点类型',
      startTime: '开始时间',
      endTime: '结束时间',
      duration: '执行时长',
      status: '状态',
      errorMsg: '错误信息',
      outputVariables: '输出变量',
      inputVariables: '输入变量',
      modelName: '模型名称',
      modelProvider: '模型提供商',
      promptTokens: 'Prompt Tokens',
      completionTokens: 'Completion Tokens',
      totalTokens: 'Total Tokens',
      executionTime: '执行耗时',
      outputData: '输出数据',
      rawResult: '原始执行结果',
      noRawData: '暂无原始数据',
      noOutputData: '暂无输出数据',
    },
    status: {
      success: '完成',
      completed: '完成',
      failed: '失败',
      error: '失败',
      ready: '已准备',
      waiting: '等待中',
      running: '运行中',
      skipped: '跳过',
    },
  },
  executionDrawer: {
    title: '执行记录详情',
    tabs: {
      result: '输出结果',
      detail: '详情',
      trace: '追踪',
    },
    workflowName: '工作流名称',
    unknownWorkflow: '未知工作流',
    executionId: '执行ID',
    requestId: '请求ID',
    sessionId: '会话ID',
    env: '环境',
    protocol: '执行标识',
    triggerType: '触发类型',
    inputParams: '输入参数',
    outputResult: '输出结果',
    noNodeRecords: '暂无节点执行记录',
    nodeData: '节点数据',
    childNodes: '子节点',
    messages: {
      loadFailed: '加载执行详情失败',
    },
  },
};
